import React from 'react';
import { Box, Typography } from '@mui/material';

const InnerPageBanner = ({ title, image }) => {
    return (
        <Box>
            {/* Banner Section */}
            <Box
                sx={{
                    position: 'relative',
                    backgroundImage: image ? `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("${image}")` : 'none',
                    bgcolor: image ? 'transparent' : '#757575',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    color: 'white',
                    py: 8,
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '500px',
                }}

            >
                {/* <Typography variant="h4" component="h1" fontWeight="bold" sx={{ textTransform: 'capitalize', position: 'relative', zIndex: 1 }}>
                    {title}
                </Typography> */}
            </Box>
        </Box>
    );
};

export default InnerPageBanner;
